<template>
  <vams-collapse
    id="billing-and-payment-collapse"
    :ref="'billing-and-payment'"
    title="Billing and Payment"
    :visible="visible"
  >
    <b-row no-gutters>
      <b-col class="customer-info-column">
        <customer-component :customer-id="customerId" :po-number="poNumber" :readonly="true" />
      </b-col>
      <b-col v-if="canViewPaymentRequest && !$isCustomer" style="border-left: 1px solid lightgray; padding-left: 15px">
        <e-pay-component
          :order-id="orderId"
          :invoice-order-id="invoiceOrderId"
          :order="order"
          :customer-id="order.customerId"
          @updateServiceOrder="updateServiceOrder"
        />
      </b-col>
      <b-col v-else></b-col>
    </b-row>
  </vams-collapse>
</template>

<script>
// components
import CollapseComponent from '@/shared/components/ui/CollapseComponent';
import EPayComponent from '@/shared/components/ui/EPayComponent';
import CustomerComponent from '@/shared/components/ui/CustomerComponent';

// vuex
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'BillingAndPaymentComponent',
  components: {
    'vams-collapse': CollapseComponent,
    'e-pay-component': EPayComponent,
    'customer-component': CustomerComponent
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    visible: Boolean(),
    authorizedRoles: {
      type: Array,
      default: () => []
    },
    isAuthorized: {
      type: Boolean,
      default: false
    },
    allowEPayInPerson: {
      type: Boolean,
      default: false
    },
    allowEPay: {
      type: Boolean,
      default: false
    },
    poNumber: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    },
    invoiceOrderId: {
      type: String,
      default: ''
    },
    order: {
      type: Object,
      default: () => {}
    },
    customerId: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters({}),
    canViewPaymentRequest() {
      return this.isAuthorized && (this.allowEPay || this.allowEPayInPerson);
    }
  },
  methods: {
    ...mapActions([]),

    async updateServiceOrder() {
      this.$emit('updateServiceOrder');
    }
  }
};
</script>
